import React, { useEffect, useState } from "react";
import MiniDrawer from "./components/drawer";
import { Outlet } from "react-router-dom";
import "../src/assets/css/index.css";
import Topbar from "./components/topbar";
import { Box, Grid } from "@mui/material";
import { StylesProvider } from '@material-ui/styles';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export default function App() {
  const [open, setOpen] = React.useState(true);
  const [visible, setVisible] = React.useState(false);
  const [title, setTitle] = useState("");
  const [subtitle, setSubTitle] = useState("");
  const [dat, getDat] = useState(false);
  const handleDrawer = (value) => {
    setOpen(value);
  };
  const resize = () => {
    if (window.innerWidth <= 760) {
      handleDrawer(false);
      setVisible(true);
    } else {
      handleDrawer(true);
      setVisible(false);
    }
  };
  const queryClient = new QueryClient();

  useEffect(() => {
    window.addEventListener("resize", () => {
      resize();
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
    <div>
      <Topbar title={title} subtitle={subtitle} dat={dat} />

      <MiniDrawer open={open} handleDrawer={handleDrawer} visible={visible} />
      <Grid component="main" className="mainbody" style={ visible === true ? { marginLeft: '40px' } : { marginLeft: '240px' } }>
        <Outlet
          context={[title, setTitle, subtitle, setSubTitle, getDat, dat]}
        />
      </Grid>
    </div>
    </QueryClientProvider>
  );
}
